module.exports = __webpack_public_path__ + "static/media/logo-title-black.68ce1050.png";